import { WORK_ORDER_TEMPLATE } from "./work-order-template.enum";
import { TPageType } from "../../common";

export function getWorkOrderTemplateName(template?: WORK_ORDER_TEMPLATE): string {
  switch (template) {
    case WORK_ORDER_TEMPLATE.INSTORE_DIGITAL:
      return "In-Store Digital";
    case WORK_ORDER_TEMPLATE.INSTORE_PRINT:
      return "In-Store Print";
    case WORK_ORDER_TEMPLATE.WEB:
      return "Web Banner";
    case WORK_ORDER_TEMPLATE.SIMPLE:
      return "Simple";
    case WORK_ORDER_TEMPLATE.EDM:
      return "General";
    case WORK_ORDER_TEMPLATE.PAID_MEDIA:
      return "Paid Media";
    case WORK_ORDER_TEMPLATE.DEALER_ADVERTISING:
    default:
      return "Branch";
  }
}

export const isWorkOrderEdmTemplate = (
  template: WORK_ORDER_TEMPLATE,
  pageType: TPageType
): boolean => pageType === "work-orders" && template === WORK_ORDER_TEMPLATE.EDM;
